import React from "react";
import {
  COMPANY_EMAIL,
  COMPANY_INSTAGRAM,
  COMPANY_YOUTUBE,
  COMPANY_LINKEDIN,
  COMPANY_NAME,
} from "../../config/constants";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useSelector } from "react-redux";

const Footer = () => {
  const { sidebarActive } = useSelector((state) => state.styles);
  return (
    <div className={`footer ${sidebarActive ? "sidebar-active" : ""}`}>
      {/* <div className="top-footer">
        <p className="social-title">Connect with us on social media</p>
        <div className="social-cont">
          <a href={`mailto:${COMPANY_EMAIL}`} className="social" target="_blank" rel="noreferrer">
            <EmailRoundedIcon />
          </a>
          <a href={COMPANY_INSTAGRAM} className="social" target="_blank" rel="noreferrer">
            <InstagramIcon />
          </a>

          <a href={COMPANY_YOUTUBE} className="social" target="_blank" rel="noreferrer">
            <YouTubeIcon />
          </a>
          <a href={COMPANY_LINKEDIN} className="social" target="_blank" rel="noreferrer">
            <LinkedInIcon />
          </a>
        </div>
      </div> */}
      <div className="bottom-footer">
        <p>
          © {new Date().getFullYear()} –{" "}
          <a href="https://www.softwarestudiopro.com" target="_blank" rel="noreferrer">
            {COMPANY_NAME}
          </a>
          . All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
